import { useEffect } from "react";
import "./WelcomePage.css";
import { useState } from "react";
import { API } from "../../Utility/API";
import { useNavigate } from "react-router-dom";

export default function WelcomePage() {
  const navigate = useNavigate();

  const [data, setData] = useState({});

  const LoninApi = async () => {
    try {
      let URL_ID = new URLSearchParams(window.location.search).get("userid");

      let res = await API.get(`WelcomeDetails?uid=${URL_ID}`);
      console.log("welcom", res.data.data[0]);

      setData(res.data.data[0]);
      // navigate("/login");
      if (res != undefined) {
        setData(res.data.data[0]);
      } else {
        LoninApi();
      }
    } catch (e) {
      console.log("WelcomPage Api", e);
    }
  };

  useEffect(() => {
    LoninApi();
  }, []);

  return (
    <>
      <div className="container-fluid welcomePage">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-md-8 mx-auto d-flex flex-column align-items-center justify-content-center h-100">
              <div className="card">
                <div className="card-body">
                    <div className="card-Heading"> WELCOME TO <span>A 2 Z</span></div>
                    <div className="card-SubHeading"> WELCOME LETTER</div>
                    <div className="name"> TO Mr./ Mrs./ Miss, <span>{data[0]?.f_name}</span></div>
                    <p>THANK YOU FOR THE REGISTRATION WITH A 2 Z. YOUR CORDIAL ASSOCIATION IS WELCOME IN THE BUSINESS FAMILY.</p>
                    <p>WISH YOU BRIGHT FUTURE FOR GROWTH !</p>
                    <div className="Nameuser">NAME : <span>{data[0]?.f_name}</span></div>
                    <div className="Userid">User Id : <span>{data[0]?.Username}</span></div>
                    <div className="Usermail">EMAIL : <span>{data[0]?.email}</span></div>
                    <div className="Usernumber">MOBILE : <span>{data[0]?.mobile}</span></div>
                    <a href="/login" className="btn px-4 py-2">Login</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
